import {GameFlowController} from '../../components/game-flow-controller.js';

export function goToRewards() {
    const gameFlow = GameFlowController.instance;

    gameFlow.goToRewards();
}
